<template lang="html">
    <div class="analytics-text-filter">
        <ds-input-field
            v-if="!hideInput"
            v-model.trim="filter.value"
        />
    </div>
</template>

<script>
export default {
    props: {
        value: Object,
    },

    data() {
        return {
            filter: this.value,
        };
    },

    watch: {
        value: {
            handler(value) {
                this.filter = value;
            },
            deep: true,
        },

        filter: {
            handler() {
                this.updateQuery();
            },
            deep: true,
        },

        'filter.modifier': function() {
            this.updateQuery();
        },
    },

    computed: {
        hideInput() {
            return this.filter.modifier === 'isempty' || this.filter.modifier === 'isfilled';
        },
    },

    methods: {
        updateQuery() {
            let query = '';

            switch (this.filter.modifier) {
            case 'equals':
                query = this.filter.value;
                break;
            case 'notequals':
                query = `-${this.filter.value}`;
                break;
            case 'contains':
                query = `%${this.filter.value}%`;
                break;
            case 'notcontain':
                query = `-%${this.filter.value}%`;
                break;
            case 'startswith':
                query = `${this.filter.value}%`;
                break;
            case 'endswith':
                query = `%${this.filter.value}`;
                break;
            case 'isempty':
                query = 'EMPTY';
                break;
            case 'isfilled':
                query = '-EMPTY';
                break;
            default:
                break;
            }

            this.filter.query = query;
        },
    },
};
</script>
